// ==================================
// Catalogo de Estados de Mexico
// con codigos SEPOMEX para consultar municipios
// ==================================

export interface EstadoMexico {
  nombre: string;
  codigo: string; // codigo SEPOMEX (2 digitos)
}

export const ESTADOS_MEXICO: EstadoMexico[] = [
  { nombre: 'Aguascalientes', codigo: '01' },
  { nombre: 'Baja California', codigo: '02' },
  { nombre: 'Baja California Sur', codigo: '03' },
  { nombre: 'Campeche', codigo: '04' },
  { nombre: 'Chiapas', codigo: '07' },
  { nombre: 'Chihuahua', codigo: '08' },
  { nombre: 'Ciudad de México', codigo: '09' },
  { nombre: 'Coahuila', codigo: '05' },
  { nombre: 'Colima', codigo: '06' },
  { nombre: 'Durango', codigo: '10' },
  { nombre: 'Estado de México', codigo: '15' },
  { nombre: 'Guanajuato', codigo: '11' },
  { nombre: 'Guerrero', codigo: '12' },
  { nombre: 'Hidalgo', codigo: '13' },
  { nombre: 'Jalisco', codigo: '14' },
  { nombre: 'Michoacán', codigo: '16' },
  { nombre: 'Morelos', codigo: '17' },
  { nombre: 'Nayarit', codigo: '18' },
  { nombre: 'Nuevo León', codigo: '19' },
  { nombre: 'Oaxaca', codigo: '20' },
  { nombre: 'Puebla', codigo: '21' },
  { nombre: 'Querétaro', codigo: '22' },
  { nombre: 'Quintana Roo', codigo: '23' },
  { nombre: 'San Luis Potosí', codigo: '24' },
  { nombre: 'Sinaloa', codigo: '25' },
  { nombre: 'Sonora', codigo: '26' },
  { nombre: 'Tabasco', codigo: '27' },
  { nombre: 'Tamaulipas', codigo: '28' },
  { nombre: 'Tlaxcala', codigo: '29' },
  { nombre: 'Veracruz', codigo: '30' },
  { nombre: 'Yucatán', codigo: '31' },
  { nombre: 'Zacatecas', codigo: '32' },
];
